import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.scss';
import { useLocomotiveScroll } from 'react-locomotive-scroll';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import useLanguage from '../../../../hooks/useLanguage';
import PropTypes from 'prop-types';

import LightBoxSecond from '../../..//UiComponents/LightBoxSecond/LightBoxSecond';
import ArrowRight from '../../../../svg/arrow_right.svg';
import ArrowLeft from '../../../../svg/arrow_left.svg';

const HomeReviews = ({ reviewsData }) => {
  
  const { scroll } = useLocomotiveScroll();

  const langToggle = useLanguage;
  const images = reviewsData.image;


  const [showLightbox, setShowLightbox] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState(0);

  function handleClick(e, index) {
    e.preventDefault();
    setShowLightbox(!showLightbox);
    setSelectedImage(index);
    scroll.stop();
  }

  function closeModal() {
    setShowLightbox(false);
    setSelectedImage(0);
    scroll.start();
  }

  React.useEffect(() => {
    window.addEventListener('keyup', handleKeyUp, false);

    return () => {
      window.removeEventListener('keyup', handleKeyUp, false);
    };
  });

  function handleKeyUp(e) {
    e.preventDefault();
    const { keyCode } = e;
    if (showLightbox) {
      if (keyCode === 27) {
        // Escape key
        setShowLightbox(false);
      }
    }
  }

  const slider = React.createRef();

  const [currentSlide, setCurrentSlide] = React.useState(0);
  const counter = currentSlide + 1;

  function handleAfterChange(index) {
    setCurrentSlide(index);
  }

  function SampleNextArrow() {
    return (
      <button
        className="slider-button slider-button__next"
        onClick={() => slider.current.slickNext()}
      >
        Next
        <ArrowRight className="slider-button__arrow" />
      </button>
    );
  }

  function SamplePrevArrow() {
    return (
      <button
        className={'slider-button slider-button__prev'}
        onClick={() => slider.current.slickPrev()}
      >
        Prev
        <ArrowLeft className="slider-button__arrow" />
      </button>
    );
  }

  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    afterChange: handleAfterChange,
  };

  return (
    <>
      <section className="home-reviews" data-scroll-section>
        <div className="content-wrapper">
          <div className="home-reviews__wrapper">
            <Slider
              ref={slider}
              {...settings}
              className={'home-reviews__slider'}
            >
              {images.map((item, index) => {
                const image = getImage(item.image.localFile);
                return (
                  <div className="home-reviews__slide" key={index}>
                    <div
                      className="home-reviews__slide-wrapper"
                      role="presentation"
                      onClick={(e) => handleClick(e, index)}
                    >
                      <GatsbyImage
                        className="home-reviews__slide-image"
                        image={image}
                        alt="shoschool review image"
                      />
                    </div>
                  </div>
                );
              })}
            </Slider>
            <div className="home-reviews__title-wrapper">
              <span className="home-reviews__marker">
                {langToggle('Відгуки', 'Отзывы')}
              </span>
              <h2 className="home-reviews__title">
                {langToggle(reviewsData.title_ua, reviewsData.title_ru)}
              </h2>
            </div>
            <div className="home-reviews__navigation-wrapper">
              <div className="steps-slider__counter">
                <span className="steps-slider__counter-current">
                  {counter <= 9 ? '0' + counter : counter}
                </span>
                <span className="steps-slider__counter-separator">/</span>
                <span className="steps-slider__counter-total">
                  {images.length <= 9 ? '0' + images.length : images.length}
                </span>
              </div>
              <div className="steps-slider__buttons">
                <SamplePrevArrow />
                <SampleNextArrow />
              </div>
            </div>
          </div>
        </div>
      </section>
      <LightBoxSecond
        closeModal={closeModal}
        showLightbox={showLightbox}
        currentImage={images[selectedImage].image.localFile}
      />
    </>
  );
};

HomeReviews.propTypes = {
  reviewsData: PropTypes.object,
};

export default HomeReviews;
